import { api } from './client';

interface LoginResponse {
  token: string;
  user: {
    id: string;
    email: string;
    name: string;
    avatarUrl: string | null;
    storageUsed: number;
    storageLimit: number;
    role: 'user' | 'admin';
  };
  expiresAt: string;
}

interface MeResponse {
  user: {
    id: string;
    email: string;
    name: string;
    avatarUrl: string | null;
    storageUsed: number;
    storageLimit: number;
    role: 'user' | 'admin';
  };
}

export const authApi = {
  login: (email: string, password: string) =>
    api.post<LoginResponse>('/auth/login', { email, password }),

  logout: () => api.post<{ success: boolean }>('/auth/logout'),

  me: () => api.get<MeResponse>('/auth/me'),

  refresh: () => api.post<{ token: string; expiresAt: string }>('/auth/refresh'),
};
